// Decisiones puras sobre la mesa seleccionada en el TPV (testeadas).
//
//  · Al recargar: ¿se restaura la última mesa seleccionada (con su cuenta y
//    su borrador) o se limpia el carrito? Nunca debe quedar contenido en el
//    carrito sin mesa seleccionada.
//  · Al cancelar el forzado de una mesa que se cobra en otro dispositivo:
//    ¿a qué mesa se vuelve?

const EMPTY_SESSION = "00000000-0000-0000-0000-000000000000";

export const isValidMesaId = (id) =>
  id != null && id !== -1 && id !== "-1" && id !== "" && id !== EMPTY_SESSION;

/**
 * Tras recargar la página.
 *  - "restore": volver a seleccionar `pendingId` y cargar su cuenta.
 *  - "clear":   limpiar el carrito (y la mesa recordada).
 *  - "none":    nada que hacer.
 *
 * Se limpia si la mesa ya no existe o si otro dispositivo tiene ahora su
 * lease (no se la quitamos por recargar). 2026-10-05 · Una mesa sin sesión ni
 * borrador (vacía, o cobrada en otro dispositivo mientras tanto) SE MANTIENE
 * seleccionada con el carrito vacío: antes se deseleccionaba y el usuario veía
 * que «al recargar se pierde la mesa». El carrito vacío ya cumple «nunca
 * contenido sin mesa».
 * `hasDraft` y `sessionOpen` (lo que dice el servidor) ya no deciden; se
 * aceptan por compatibilidad con los llamadores.
 * Sin mesa recordada, un carrito con líneas es huérfano → se limpia (el
 * borrador por mesa sigue guardado aparte).
 */
export function decideSelectionRestore({
  pendingId,
  mesa,
  presenceHolder,
  myDeviceId,
  cartHasLines,
}) {
  if (!isValidMesaId(pendingId)) return cartHasLines ? "clear" : "none";
  if (!mesa) return "clear";
  if (presenceHolder?.deviceId && presenceHolder.deviceId !== myDeviceId) return "clear";
  return "restore";
}

/**
 * Al cancelar el forzado: volver a la mesa en la que estaba antes de pulsar
 * la que se cobra (solo escritorio; en móvil pulsar una mesa ya era entrar
 * y se vuelve al plano). null = sin mesa anterior → plano limpio.
 */
export function previousMesaAfterCancel({ previousId, promptMesaId, mesas, isMobile }) {
  if (isMobile) return null;
  if (!isValidMesaId(previousId) || String(previousId) === String(promptMesaId)) return null;
  return (mesas || []).find((m) => String(m.id) === String(previousId)) || null;
}
